export const SORT_TYPE = {
    None: 'none',
    Current: 'current',
    Prev: 'prev',
    Diff: 'diff',
} as const;

export type SortType = (typeof SORT_TYPE)[keyof typeof SORT_TYPE];
export type SortDirection = 'asc' | 'desc' | null;

export interface SortSelectedItem {
    column: string;
    sortType: SortType;
    direction: SortDirection;
}
export type CompareSortSelection = Pick<SortSelectedItem, 'sortType' | 'direction'>;
export const SORT_DROPDOWN_ALIGN = {
    Start: 'start',
    Center: 'center',
    End: 'end',
} as const;

export type SortDropdownAlign = (typeof SORT_DROPDOWN_ALIGN)[keyof typeof SORT_DROPDOWN_ALIGN];
export const SORT_DROPDOWN_ALIGN_LEFT_MAX_INDEX = 1;